export const TRANSITION_MS = 220;

export enum Transitions {
  fade = 'fade',
  popFromBottom = 'pop-from-bottom',
  collapse = 'collapse',
}
